// extracted by mini-css-extract-plugin
export default {"body":"AllMajorZK_body__AGSkJ"};